import React from 'react'
import {
    BackButton,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ListingCredit,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue12() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelles sont les charges mensuelles de votre foyer ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <Conditionnal
                        linked_data_id="emp_type_emprunteur"
                        isEqualTo
                        targetDataValueCompare="2"
                    >
                        <BackButton targetView={22} />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emp_type_emprunteur"
                        isNotEqualTo
                        targetDataValueCompare="2"
                    >
                        <BackButton targetView={11} />
                    </Conditionnal>
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={80} time={1} />
            </div>

            <div className="Container">
                <BlocIntField
                    key="key113"
                    nbcolumn={1}
                    linked_data_id="pension_out"
                    symbole=" €"
                    label="Pensions alimentaires à verser et/ou prestation compensatoire mensuelles"
                    placeholder="Ex : 100 € / mois"
                />
            </div>
            <div className="Container">
                <Conditionnal
                    linked_data_id="prj_type"
                    isEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Title
                        maintitle="Crédits existants (hors crédit à renégocier)"
                        secondarytitle="N'indiquez ici que les crédits en cours qui NE seront PAS remboursés dans les trois mois suivant votre renégociation, en précisant la durée restante (et non pas la durée totale du prêt)."
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_type"
                    isNotEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Title
                        maintitle="Crédits existants"
                        secondarytitle="N'indiquez ici que les crédits en cours qui NE seront PAS remboursés dans les trois mois suivant votre achat, en précisant la durée restante (et non pas la durée totale du prêt)."
                    />
                </Conditionnal>
                <ListingCredit />
            </div>

            <div className="Container">
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={13} />{' '}
                </div>
            </div>
        </div>
    )
}
